import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PreviousRouteService } from 'src/app/services/previousRouteService';

/**
 * Landing page component of the application.
 *
 * Responsibilities:
 * - Stores the previous route when the component initializes.
 */
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingpageComponent implements OnInit {

  /**
   * Creates an instance of LandingpageComponent.
   *
   * @param locationStrategy - Angular LocationStrategy to access the current path.
   * @param previousRouteService - Service to store the previous route for navigation tracking.
   */
  constructor(
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService
  ) { }

  /**
   * Angular lifecycle hook called on component initialization.
   *
   * - Stores the current route as the previous route using PreviousRouteService.
   */
  ngOnInit(): void {
    this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
  }

}
